import { API_CONFIG } from 'config/api';

// Fetch CSRF token and set it in Redux
export const fetchCsrfToken = async () => {
  const response = await fetch(API_CONFIG.csrfEndpoint);
  const data = await response.json();
  if (data.csrftoken) {
    return data.csrftoken;
  }
  throw new Error('Failed to fetch CSRF token');
};
